import { FacetLabels } from '../models/facet-labels.model';

export function createEmptyFacetLabels(): FacetLabels {
  return {
    domains: {},
    categories: {},
    types: {},
    availabilityTypes: {},
    counties: {},
    cities: {},
    annexes: {},
    areas: {},
    targetAudiences: {}
  };
}
